import axios from '@/axios.js'

export default {
  addRoles({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post('/roles', item)
        .then((response) => {
          commit('ADD_ROLE', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateRoles({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/roles/' + item.id, item)
        .then((response) => {
          commit('UPDATE_ROLE', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchRoles({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/roles', {
          params: payload,
        })
        .then((response) => {
          commit('SET_ROLES', response.data)
          commit('SET_PAGINATION', {
            currentPage: parseInt(response.headers['x-pagination-page']),
            totalPage: parseInt(response.headers['x-pagination-page-count']),
            pageTotal: parseInt(response.headers['x-pagination-count']),
            totalItem: parseInt(response.headers['x-pagination-total']),
          })

          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchRole(context, roleId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/admin/roles/${roleId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeRole({ commit }, roleId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/roles/${roleId}`)
        .then((response) => {
          commit('REMOVE_ROLE', roleId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchPermissions({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/permissions')
        .then((response) => {
          commit('SET_PERMISSIONS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
